<template>
    <v-container class="pa-0 ma-0" fluid style="background-color: #EEEEE7; height:100% ">
        <!-- Template para Web -->
        <div v-if="!isMobile">
            <v-toolbar class="slide-card-up" dense :color="'#FBFAF1'" style="min-height: 80px;"> <v-spacer></v-spacer>
                <v-toolbar-title class="mt-6 text-center">
                    <img src="../assets/logo7.svg" alt="Logo" style="height: 60px;">
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-row dense class="slide-card-up" justify="center">
                <h1 v-if="camino != null" class="mt-12 ma-4 mr-12">{{ $t('mensajes.inicial') }}</h1>
            </v-row>
            <v-row v-if="camino != null" dense class="slide-card-up">
                <v-col class="text-center">
                    <p style="font-size: 1.2rem;" class="mx-16">
                        {{ $t('mensajes.descripcion') }}
                    </p>
                </v-col>
            </v-row>

            <v-container v-if="camino != null">

                <!-- Envío del presupuesto -->
                <v-row justify="center" class="mt-12">
                    <v-col cols="12" sm="8" md="6" class="text-center">
                        <!-- Card Final Presupuesto enviado -->
                        <v-card class="pa-6 card-personalizada slide-card">
                            <v-card-text>
                                <v-row justify="center" class="mb-4">
                                    <h1> {{ $t('mensajes.presupuesto_enviado') }}</h1>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- Card Resumen Presupuesto -->
                        <v-card v-if="this.camino" class="mt-6 pa-6 card-personalizada slide-card">
                            <v-card-text>
                                <v-row justify="center" class="mb-4">
                                    <v-col cols="4" align="center">
                                        <v-img v-if="this.camino.etapas[0].imagen_base64"
                                            :src="this.camino.etapas[0].imagen_base64" width="200px" height="200px"
                                            style="border-radius: 20px;"></v-img>
                                    </v-col>
                                    <v-col align="start">
                                        <p>
                                            {{ this.languageSelected == 'en' ? this.camino.resumen_EN :
                                                this.languageSelected == 'de' ? this.camino.resumen_DE :
                                                    this.camino.resumen }}
                                        </p>


                                    </v-col>
                                </v-row>

                                <v-row class="mt-4 mb-2" justify="end">
                                    <v-chip link @click="_irAWebAlCamino()" large class="ma-2 px-8 mr-8 hover-color"
                                        :color="miColorAzul" :text-color="miColorNaranja" style="font-size: 1.2rem;">
                                        {{ $t('mensajes.ir_al_camino') }}
                                        <v-icon size="2rem" right>mdi-arrow-right</v-icon>
                                    </v-chip>
                                </v-row>
                            </v-card-text>
                        </v-card>


                    </v-col>
                </v-row>

            </v-container>
        </div>

        <!-- Template para Móvil -->
        <div v-else>
            <v-toolbar class="slide-card-up" dense :color="'#EEEEE7'" style="min-height: 60px;">
                <v-spacer></v-spacer>
                <v-toolbar-title class="mt-4 text-center">
                    <img src="../assets/logo7.svg" alt="Logo" style="height: 40px;">
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container class="mt-0 v-container-movil" v-if="camino != null">

                <!-- Envío del presupuesto -->
                <v-row justify="center" class="mt-4">
                    <v-col cols="12" sm="8" md="6" class="text-center">

                        <!-- Card Final Presupuesto enviado -->
                        <div class="slide-card">
                            <v-row justify="center" class="mb-4">
                                <h2> {{ $t('mensajes.presupuesto_enviado') }}</h2>
                            </v-row>
                        </div>

                        <!-- Card Resumen Presupuesto -->
                        <div v-if="this.camino" class="mt-2 pa-6 slide-card">
                            <v-row justify="center" class="mb-4">
                                <v-col align="center">
                                    <v-img v-if="this.camino.etapas[0].imagen_base64"
                                        :src="this.camino.etapas[0].imagen_base64" width="200px" height="200px"
                                        style="border-radius: 20px;"></v-img>
                                </v-col>

                            </v-row>
                            <v-row justify="center" class="mb-4">

                                <v-col align="start">
                                    <p>
                                        {{ this.language == 'en' ? this.camino.resumen_EN :
                                            this.language == 'de' ? this.camino.resumen_DE :
                                                this.camino.resumen }}
                                    </p>


                                </v-col>
                            </v-row>

                            <v-row class="mt-4 mb-6" justify="center">
                                <v-chip link @click="_irAWebAlCamino()" large class="ma-2 px-8 mr-8 hover-color"
                                    :color="step >= 1 ? miColorAzul : miColorNaranja"
                                    :text-color="step >= 1 ? miColorNaranja : miColorAzul" style="font-size: 1.2rem;">
                                    {{ $t('mensajes.ir_al_camino') }}
                                    <v-icon size="2rem" right>mdi-arrow-right</v-icon>
                                </v-chip>
                            </v-row>
                        </div>
                    </v-col>
                </v-row>






            </v-container>

            <!-- Footer fijo con información del presupuesto -->
            <v-footer v-if="datosMinimosCompletados && !mostrarResumen" class="fixed-footer" :color="miColorNaranja">
                <v-container class="pa-0">
                    <v-row dense justify="center">
                        <!-- Información del presupuesto -->
                        <v-col cols="4" sm="4" class="text-center text-sm-left">
                            <div>
                                <span>{{ $t('mensajes.datos_reserva.importe_total') }}</span>
                                <h3>{{ importeTotal }} €</h3>
                            </div>
                        </v-col>
                        <v-divider vertical></v-divider>
                        <v-col cols="4" sm="4" class="text-center text-sm-left">
                            <div>
                                <span>{{ $t('mensajes.datos_reserva.peregrinos') }}</span>
                                <h3>{{ this.modelReserva.cant_peregrinos }}</h3>
                            </div>
                        </v-col>
                        <v-divider vertical></v-divider>
                        <v-col cols="4" sm="4" class="text-center text-sm-left">
                            <div>
                                <span>{{ $t('mensajes.datos_reserva.precio_por_peregrino') }}</span>
                                <h3>{{ precioPorPeregrino }} €</h3>
                            </div>
                        </v-col>




                    </v-row>
                </v-container>
            </v-footer>

        </div>
    </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {
            windowWidth: window.innerWidth,
            miColorNaranja: '#FF9C00',
            miColorAzul: '#191970',
            miColorAmarillo: '#FFF6E5',
        };
    },

    created() {

    },

    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.$i18n.locale = this.languageSelected.toLowerCase();
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },

    computed: {
        ...mapState("caminos", ["camino", "languageSelected"]),

        isMobile() {
            return this.windowWidth <= 768;
        },

    },

    methods: {

        handleResize() {
            this.windowWidth = window.innerWidth;
        },

        _irAWebAlCamino() {
            if (this.language == 'en') {
                window.open(this.camino.link_web, '_blank');
            } else if (this.language == 'de') {
                window.open(this.camino.link_web, '_blank');
            } else {
                window.open(this.camino.link_web, '_blank');
            }
        },

    },
};
</script>

<style scoped>
@import 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/css/flag-icon.min.css';

.card-personalizada {
    border: 4px solid #FF9C00 !important;
    border-radius: 15px !important;
}

.flying-document-container {
    position: relative;
    height: 150px;
    width: 100%;
    overflow: hidden;
}

.flying-document {
    position: relative;
    animation: fly 2s infinite ease-in-out;
}

.wind-line {
    position: absolute;
    height: 2px;
    background: #FF9C00;
    opacity: 0.6;
    animation: wind 2s infinite ease-in-out;
}

.wind-line-1 {
    width: 50px;
    top: 40%;
    left: 30%;
}

.wind-line-2 {
    width: 30px;
    top: 50%;
    left: 45%;
    animation-delay: 0.2s;
}

.wind-line-3 {
    width: 40px;
    top: 60%;
    left: 35%;
    animation-delay: 0.4s;
}


@keyframes fly {
    0% {
        transform: translateX(-100%) translateY(20px) rotate(0deg);
    }

    50% {
        transform: translateX(0) translateY(0px) rotate(5deg);
    }

    100% {
        transform: translateX(100%) translateY(20px) rotate(0deg);
    }
}

@keyframes wind {
    0% {
        transform: translateX(-100%) scaleX(0.5);
        opacity: 0;
    }

    50% {
        opacity: 0.6;
    }

    100% {
        transform: translateX(100%) scaleX(1);
        opacity: 0;
    }
}

.pulse-text {
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }

    100% {
        opacity: 1;
    }
}

.slide-card {
    animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

/* Para la animación de salida */
.slide-card.v-leave-active {
    animation: slideOut 0.5s ease-in;
}

@keyframes slideOut {
    from {
        transform: translateX(0);
        opacity: 1;
    }

    to {
        transform: translateX(-100%);
        opacity: 0;
    }
}

.slide-card-up {
    animation: slideInUp 0.5s ease-out;
}

@keyframes slideInUp {
    from {
        transform: translateY(-100%);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

/* Para la animación de salida */
.slide-card-up.v-leave-active {
    animation: slideOutDown 0.5s ease-in;
}

@keyframes slideOutDown {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(100%);
        opacity: 0;
    }
}


.fixed-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    height: 80px;
    border-top: 2px solid #FF9C00;
}

/* Ajustar el contenido para que no se oculte detrás del footer */
.v-container-movil {
    padding-bottom: 80px;
    /* Altura del footer + margen */
}



/* Para móvil, ajustar más el padding */
@media (max-width: 768px) {
    .v-container-movil {
        padding-bottom: 100px;
    }
}


/* Prevenir pull-to-refresh en móviles */
html,
body {
    overscroll-behavior: none;
    -webkit-overflow-scrolling: touch;
    overflow: hidden;
    position: fixed;
    width: 100%;
    height: 100%;
}

/* Para el contenedor principal */
.v-application {
    overscroll-behavior: none;
    -webkit-overflow-scrolling: touch;
    height: 100vh;
    overflow-y: auto;
}

/* Para el contenedor específico de tu aplicación */
.v-container {
    overscroll-behavior: none;
    -webkit-overflow-scrolling: touch;
}
</style>
